import styled from 'styled-components';

const LinkListComponent = styled.div``;

const Header = styled.h3`
  font-size: var(--text-300);
  margin: 0 0 0.75rem;
`;
const List = styled.ul`
  margin: 0;
  padding: 0;
`;
const ListItem = styled.li`
  list-style-type: none;
  margin: 0 0 0.5rem;
  padding: 0;
`;
const Link = styled.a``;

LinkListComponent.Header = Header;
LinkListComponent.List = List;
LinkListComponent.ListItem = ListItem;
LinkListComponent.Link = Link;

export default LinkListComponent;
